import { Instagram, Mail } from "lucide-react";
import { usePagesContent } from "@/data/pages";

export const Footer = () => {
  const { footer } = usePagesContent();

  return (
    <footer
      data-testid="footer"
      className="bg-[#2A1810] py-14 px-6 lg:px-10"
    >
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
        <div>
          <p className="font-serif-display text-2xl text-[#FBF6EA]">
            <span className="text-[#C99873]">{footer.brand_part1}</span>{" "}
            {footer.brand_part2}{" "}
            <span className="font-serif-italic text-[#7AB8D6]">
              {footer.brand_part3}
            </span>
          </p>
          <p className="overline text-[#FBF6EA]/50 mt-2">{footer.copyright}</p>
        </div>
        <div className="flex items-center gap-5 text-[#FBF6EA]/70">
          {footer.email && (
            <a
              href={`mailto:${footer.email}`}
              className="hover:text-[#F4C77B] transition"
              data-testid="footer-email"
            >
              <Mail size={18} />
            </a>
          )}
          {footer.instagram_url && (
            <a
              href={footer.instagram_url}
              target="_blank"
              rel="noreferrer"
              className="hover:text-[#F4C77B] transition"
              data-testid="footer-instagram"
              aria-label="Instagram"
            >
              <Instagram size={18} />
            </a>
          )}
        </div>
      </div>
    </footer>
  );
};
